import { SnackbarProvider } from "notistack";
import { ComponentProps } from "react";

type LayerSnackbarProviderProps = ComponentProps<typeof SnackbarProvider>;

export const LayerSnackbarProvider = (props: LayerSnackbarProviderProps) => {
  return <SnackbarProvider {...props} maxSnack={4} />;
};
